export default __webpack_public_path__ + "static/media/panel-logo-light.5d957568.png";